import React, { useEffect, useState } from "react";
import axios from "axios";
import background from "../image/qw-removebg-preview.png";

const Ingret = () => {
  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIngredients = async () => {
      try {
        const { data } = await axios.get(
          "https://dharajwebbackend.concentics.com/api/Ingredient_data"
        );

        const ingredientList = data?.data || data?.ingredients || [];

        if (Array.isArray(ingredientList) && ingredientList.length > 0) {
          setIngredients(ingredientList);
        } else {
          setError("No ingredients found.");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to fetch ingredients from the backend.");
      } finally {
        setLoading(false);
      }
    };

    fetchIngredients();
  }, []);

  if (loading)
    return <p className="text-center py-5">Loading ingredients...</p>;

  if (error)
    return <p className="text-center py-5 text-danger">{error}</p>;

  return (
    <section
      className="ingredient-section py-5"
      style={{
        backgroundColor: "var(--bg-main)",
        color: "var(--color-secondary)",
        backgroundImage: `url(${background})`,
        backgroundSize: "contain",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container py-5">
        {ingredients.map((item, index) => {
          const images = item.img ? item.img.split(",") : [];

          return (
            <div key={item._id || index} className="ingredient-block mb-5">
              {/* Title */}
              <h1 className="ingredient-title text-center mb-3">
                {item.title}
              </h1>

              {/* Images Grid */}
              <div className="row pt-4 justify-content-center g-3">
                {images.map((img, idx) => (
                  <div
                    className="col-6 col-sm-4 col-md-3 col-lg-3"
                    key={idx}
                  >
                    <img
                      src={`https://dharajwebbackend.concentics.com/productimage/${img}`}
                      alt={item.title}
                      className="img-fluid ingredient-img"
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* Inline CSS for responsiveness */}
      <style>
        {`
          /* Title font - desktop stays same */
          .ingredient-title {
            font-family: var(--font-primary);
            font-size: var(--font-xxl);
            font-weight: 700;
            color: var(--color-secondary);
          }

          /* Images - desktop default */
          .ingredient-img {
            border-radius: var(--border-radius-btn);
            box-shadow: var(--box-shadow-card);
            width: 100%;
            height: auto;
            object-fit: cover;
            transition: transform 0.3s;
          }

          /* Small screens adjustments */
          @media (max-width: 768px) {
            .ingredient-title {
              font-size: 1.9rem; /* smaller font on mobile */
            }

            .ingredient-img {
              height: 220px; /* shrink images slightly on mobile */
            }
          }

          @media (max-width: 576px) {
            .ingredient-title {
              font-size: 1.9rem; /* even smaller on tiny screens */
            }

            .ingredient-img {
              height: 220px; /* smaller images on very small screens */
            }
          }
        `}
      </style>
    </section>
  );
};

export default Ingret;
